const elm = require('../../../elm/elm.js');

document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('testimonial-widget-container');

  if (container) {
    const flags = JSON.parse(container.dataset.flags || '{}');
    const app = elm.TestimonialWidget.embed(container, flags);
  }
});
